import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalResponseCodes } from '@src/suite/common/components/modal/modal.service';

export interface ConfirmationData {
    title: string;
    message: string;
    yesLabel?: string;
    noLabel?: string;
    cancelLabel?: string;
}

@Component({
    selector: 'st-confirmation-modal',
    templateUrl: './confirmation.html',
    styleUrls: ['../modal/modal.scss'],
    host: {
        class: 'st-confirmation',
    },
    encapsulation: ViewEncapsulation.None,
})
export class ConfirmationModalComponent {
    public title: string;
    public message: string;
    public yesLabel: string;
    public noLabel: string;
    public cancelLabel: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationData
    ) {
        this.title = data.title;
        this.message = data.message;
        this.yesLabel = data.yesLabel || 'Yes';
        this.noLabel = data.noLabel || 'No';
        this.cancelLabel = data.cancelLabel || 'Cancel';
    }

    onYesClick(): void {
        this.dialogRef.close(ModalResponseCodes.OK);
    }

    onNoClick(): void {
        this.dialogRef.close(ModalResponseCodes.DISCARD);
    }

    onCancelClick(): void {
        this.dialogRef.close(ModalResponseCodes.CANCEL);
    }
}
